// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"5a215ec7","781":"d4b51956"}[chunkId] + ".chunk.css";
};